// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1P1Zl","top":"styles_top__jLImo"};